import {
  CsvMap,
  ExportCsvData,
  ExportCsvDataTrigger,
} from "@src/components/modules/Table/TableActions/ExportCsvData";
import { capitalCase } from "change-case";
import React, { forwardRef, ReactElement, useMemo } from "react";
import { Row } from "react-table";

interface Props<T extends Record<string, unknown>> {
  rows: Row<T>[];
  transformExportedColumn?: (
    columnName: string,
    value?: string | number | null,
  ) => [string, string | number | null | undefined];
  customCsvExport?: (data: Row<T>[]) => () => {
    data: CsvMap[];
    columns: string[];
  };
}

const TableCsvDownload = forwardRef(
  <T extends Record<string, unknown>>(
    props: Props<T>,
    exportCsvRef: React.Ref<ExportCsvDataTrigger>,
  ): ReactElement => {
    const { rows, transformExportedColumn, customCsvExport } = props;

    const getFilteredCsvData = useMemo<() => CsvMap[]>(() => {
      return () => {
        return rows.reduce<CsvMap[]>((acc, row) => {
          const { values } = row;
          const keys = Object.keys(values);
          const m = {} as CsvMap;
          for (const key of keys) {
            if (key !== "id" && key !== "expander" && key !== "actions") {
              m[capitalCase(key)] = (values as unknown as CsvMap)[key];
            }
          }
          acc.push(m);
          return acc;
        }, []);
      };
    }, [rows]);

    return (
      <>
        <ExportCsvData
          style={{ display: "none" }}
          name="data"
          buttonText="Export"
          data={customCsvExport ? customCsvExport(rows) : getFilteredCsvData}
          transformColumn={transformExportedColumn}
          ref={exportCsvRef}
        />
      </>
    );
  },
);

export default TableCsvDownload as <T extends Record<string, unknown>>(
  props: Props<T> & {
    ref: React.Ref<ExportCsvDataTrigger>;
  },
) => ReactElement;
